import { useEffect } from "react";

const DEFAULT_TITLE = "Money Protocol";
const DEFAULT_DESCRIPTION =
  "Borrow against Bitcoin at 0% interest with Money Protocol. Get instant liquidity without selling BTC.";
const DEFAULT_CANONICAL = "https://www.moneyprotocol.co/";

function setMetaContent(selector, value) {
  const el = document.querySelector(selector);
  if (el) el.setAttribute("content", value);
}

export default function usePageMeta(title, description, canonicalUrl) {
  useEffect(() => {
    const resolvedTitle = title || DEFAULT_TITLE;
    const resolvedDescription = description || DEFAULT_DESCRIPTION;
    const resolvedCanonical = canonicalUrl || DEFAULT_CANONICAL;

    document.title = resolvedTitle;

    setMetaContent('meta[name="description"]', resolvedDescription);

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute("href", resolvedCanonical);
    }

    setMetaContent('meta[property="og:title"]', resolvedTitle);
    setMetaContent('meta[property="og:description"]', resolvedDescription);
    setMetaContent('meta[property="og:url"]', resolvedCanonical);

    setMetaContent('meta[name="twitter:title"]', resolvedTitle);
    setMetaContent('meta[name="twitter:description"]', resolvedDescription);
  }, [title, description, canonicalUrl]);
}
